import * as Redux from 'redux';
import ReduxThunk from 'redux-thunk';
import rootReducer from './rootReducer';
import * as DataViewActions from './actions/dataView';
import * as Error from './utils/error';

export let store = {};

const emptyArray = [];

export const createStore = (initialState = initialState, initialProps = {}) => {
    store = Redux.createStore(
        rootReducer,
        initialState,
        Redux.compose(
            Redux.applyMiddleware(ReduxThunk),
            typeof window === 'object' && typeof window.devToolsExtension !== 'undefined' ? window.devToolsExtension() : (f) => f
        )
    );

    store.dispatch(
        DataViewActions.init(initialProps)
    ).catch((error) => {
        Error.send(
            error,
            'createStore'
        );
    });

    return store;
};

const normalizeArrayById = (array = emptyArray) =>
    array.reduce((accumulator, item) => {
        accumulator[item.id] = item;
        return accumulator;
    }, {});

export const createInitialState = (props = {}) => ({
    filerrs: normalizeArrayById(props.filerrs),
    settings: {
        source: props.source,
        withModalBehavior: props.withModalBehavior,
        withCollaboration: props.withCollaboration,
        withPreRevision: props.withPreRevision,
        withUnsubscribe: props.withUnsubscribe,
        withRevision: props.withRevision,
        withPostRevision: props.withPostRevision,
        contextType: props.contextType,
        contextId: props.contextId,
        standalone: !props.withModalBehavior || false,
        requiredGroupType: props.requiredGroupType,
        teamId: props.teamId,
        showPdfViewer: props.showPdfViewer
    },
    current: {
        userId: props.userId,
        collaboratorId: props.collaboratorId,
        reviewId: props.reviewId
    },
    tempAnnotations: emptyArray,
    annotationsHidden: false,
    callbacks: props.callbacks,
    commentBoxCancelled: false
});
